import { buildOAuthAuthorizeUrl } from '@api/auth/config';
import { isOAuthTokenValid } from '@api/auth/oauthToken';
import { saveReturnUrl } from '@hooks/useAuth';
import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/builder/$slug')({
  beforeLoad: () => {
    if (!isOAuthTokenValid()) {
      saveReturnUrl();
      throw redirect({ href: buildOAuthAuthorizeUrl() });
    }
  },
});
